import { TestIdDomain } from 'constants/testIds';

const ConditionsScope = 'conditions';
const EditConditionModalScope = 'edit-condition-modal';
const AdhocConditionFieldsScope = 'adhoc-condition-fields';
const AddBrokerConditionFormScope = 'add-broker-condition-form';
const AddConditionTasksFormScope = 'add-condition-tasks-form';
const LinkConditionTasksDrawerScope = 'link-condition-tasks-drawer';
const AddConditionsContentScope = 'add-conditions';
const ConditionHistoryDrawerScope = 'condition-history-drawer';
const RejectConditionDrawerScope = 'reject-condition-drawer';

export const ConditionsTestIds = {
  SECTION: `${TestIdDomain.UNDERWRITING}.${ConditionsScope}`,
  TABS: `${ConditionsScope}.tabs`,
  TABLE: `${ConditionsScope}.table`,
  ADD_BUTTON: `${ConditionsScope}.add-button`,
  ROW_ACTION_BUTTON: `${ConditionsScope}.row-action-button`,
  getRowId: id => `${ConditionsScope}.row-${id}`,

  // EditConditionModal
  EDIT_DRAWER: `${TestIdDomain.UNDERWRITING}.${EditConditionModalScope}`,
  EDIT_TITLE_INPUT: `${EditConditionModalScope}.title-input`,
  EDIT_CONDITION_MESSAGE_INPUT: `${EditConditionModalScope}.condition-message-input`,
  EDIT_BORROWER_MESSAGE_INPUT: `${EditConditionModalScope}.borrower-message-input`,
  EDIT_SUB_COMPANY_MESSAGE_INPUT: `${EditConditionModalScope}.sub-company-message-input`,
  EDIT_COPY_FROM_LINK: `${EditConditionModalScope}.copy-from-link`,
  EDIT_CATEGORY_SELECT: `${EditConditionModalScope}.category-select`,
  EDIT_PRIOR_TO_SELECT: `${EditConditionModalScope}.prior-to-select`,
  EDIT_CANCEL_BUTTON: `${EditConditionModalScope}.cancel-button`,
  EDIT_SAVE_BUTTON: `${EditConditionModalScope}.save-button`,

  // ConditionHistoryDrawer
  HISTORY_DRAWER: `${TestIdDomain.UNDERWRITING}.${ConditionHistoryDrawerScope}`,

  // RejectConditionDrawer
  REJECT_DRAWER: `${TestIdDomain.UNDERWRITING}.${RejectConditionDrawerScope}`,
  REJECT_REASON_INPUT: `${RejectConditionDrawerScope}.reason-input`,
  REJECT_SUBMIT_BUTTON: `${RejectConditionDrawerScope}.submit-button`,

  // AdhocConditionFields
  ADHOC_MESSAGE_INPUT: `${AdhocConditionFieldsScope}.message-input`,
  ADHOC_BORROWER_MESSAGE_INPUT: `${AdhocConditionFieldsScope}.borrower-message-input`,
  ADHOC_PRIOR_TO_SELECT: `${AdhocConditionFieldsScope}.prior-to-select`,
  ADHOC_SLA_GROUP_SELECT: `${AdhocConditionFieldsScope}.sla-group-select`,

  // AddBrokerConditionForm
  BROKER_FORM_CANCEL_BUTTON: `${AddBrokerConditionFormScope}.cancel-button`,
  BROKER_FORM_SUBMIT_BUTTON: `${AddBrokerConditionFormScope}.submit-button`,

  // AddConditionTasksForm
  TASKS_FORM_CANCEL_BUTTON: `${AddConditionTasksFormScope}.cancel-button`,
  TASKS_FORM_SUBMIT_BUTTON: `${AddConditionTasksFormScope}.submit-button`,

  // LinkConditionTasksDrawer
  LINK_TASKS_DRAWER: `${TestIdDomain.UNDERWRITING}.${LinkConditionTasksDrawerScope}`,
  LINK_TASKS_SELECT: `${LinkConditionTasksDrawerScope}.tasks-select`,
  LINK_TASKS_SUBMIT_BUTTON: `${LinkConditionTasksDrawerScope}.submit-button`,

  // AddConditionsContent
  CONDITIONS_SELECT: `${AddConditionsContentScope}.conditions-select`,
  CONDITION_SETS_SELECT: `${AddConditionsContentScope}.condition-sets-select`,
  FILTER_PRIOR_TO_SELECT: `${AddConditionsContentScope}.filter-prior-to-select`,
  FILTER_CATEGORY_SELECT: `${AddConditionsContentScope}.filter-category-select`,

  // ConditionDetailCard (mapped per condition/task)
  getConditionDeleteButtonId: conditionId => `condition-${conditionId}.delete-button`,
  getConditionExpandButtonId: conditionId => `condition-${conditionId}.expand-button`,
  getConditionCategorySelectId: conditionId => `condition-${conditionId}.category-select`,
  getConditionPriorToSelectId: conditionId => `condition-${conditionId}.prior-to-select`,
  getConditionMessageInputId: conditionId => `condition-${conditionId}.message-input`,
  getConditionNumberInputId: conditionId => `condition-${conditionId}.number-input`,
  getConditionBorrowerMessageInputId: conditionId =>
    `condition-${conditionId}.borrower-message-input`,
  getConditionSubCompanyMessageInputId: conditionId =>
    `condition-${conditionId}.sub-company-message-input`,
  getConditionTaskTypeSelectId: conditionId => `condition-${conditionId}.task-type-select`,
  getTaskRemoveButtonId: taskTypeId => `task-${taskTypeId}.remove-button`,
  getTaskExpandButtonId: taskId => `task-${taskId}.expand-button`,
};
